import React from 'react';
import classNames from 'classnames';

export default function SecurityBadgeIcon({ className = '' }) {
	return <span className={classNames('icon icon-safety_and_security', className)} />;
}
